import {NgModule, Input} from '@angular/core'; // added Input for binding

// import {MatSlideToggleModule} from "@angular/material/slide-toggle";
// import {FormsModule} from "@angular/forms";
// import {TranslateModule} from "@ngx-translate/core";
// import {MatButtonModule} from "@angular/material/button";
// import {MatDialogModule} from "@angular/material/dialog";


// dummy component (only debug)
// import {DummyComponent} from '../components/Dummy.component';


// for routing
// import {LibCommRoutingModule} from "./libComm.routing.module";


@NgModule({
	declarations: [
		// DummyComponent, // only for not-standalone components !
		// ActionBarComponent,
		// DialogComponent,
		// SaveConfirmComponent,
		// AppInfoComponent,
	],
	imports: [
		// DummyComponent
		// MatButtonModule,
		// MatDialogModule,
		// MatSlideToggleModule,
		// TranslateModule,
		// FormsModule
	],
	exports: [
		// DummyComponent,
		// MatButtonModule,
		// MatDialogModule,
		// MatSlideToggleModule,
		// TranslateModule,
		// FormsModule
	]
})
export class LibCommModule
{
}
